import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { TsButtonModule, TsInputComponent } from 'tsui';
import { TsSelectModule } from 'tsui/lib/ts-select/ts.select.module';
import { TsDialogComponent } from 'tsui/lib/ts-dialog/ts-dialog.component';
import { Store } from '@ngxs/store';
import { AssetManagementState } from '../../state/asset-management.state';
import { AssetManagementActions } from '../../state/asset-management.actions';

export interface AccountMappingDialogData {
  account_mapping_id?: number;
  category_account_id?: number;
  regular_account_id?: number;
}

@Component({
  selector: 'account-mapping-management-dialog',
  standalone: true,
  imports: [AsyncPipe, ReactiveFormsModule, TsButtonModule, TsDialogComponent, TsInputComponent, TsSelectModule],
  templateUrl: './account-mapping-management-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountMappingManagementDialogComponent {
  readonly dialogRef = inject(DialogRef);
  readonly data = inject<AccountMappingDialogData>(DIALOG_DATA);
  readonly store = inject(Store);
  readonly fb = inject(FormBuilder);

  readonly accountMappingForm = this.fb.group({
    category_account_id: [this.data?.category_account_id || null, Validators.required],
    regular_account_id: [this.data?.regular_account_id || null, Validators.required],
  });

  readonly categoryOptions$ = this.store.select(AssetManagementState.categoryAccountOptions);
  readonly regularAccounts$ = this.store.select(AssetManagementState.regularAccountsOptions);

  ngOnInit(): void {
    this.store.dispatch(AssetManagementActions.LoadCategoryAccounts);
    this.store.dispatch(AssetManagementActions.LoadRegularAccounts);
  }

  get accountMappingFormControls() {
    return {
      categoryAccountId: this.accountMappingForm.get('category_account_id'),
      regularAccountId: this.accountMappingForm.get('regular_account_id'),
    };
  }

  get isSubmitable(): boolean {
    return this.accountMappingForm.valid && this.accountMappingForm.dirty;
  }

  submitForm(): void {
    if (!this.isSubmitable) return;

    this.dialogRef.close(<AccountMappingDialogData>{
      account_mapping_id: this.data?.account_mapping_id,
      category_account_id: +this.accountMappingForm.get('category_account_id')?.value,
      regular_account_id: +this.accountMappingForm.get('regular_account_id')?.value,
    });
  }
}
